import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import MobileActionBar from "@/components/MobileActionBar";
import Home from "@/pages/Home";
import Destinations from "@/pages/Destinations";
import DestinationDetail from "@/pages/DestinationDetail";
import Opportunities from "@/pages/Opportunities";
import ProjectDetail from "@/pages/ProjectDetail";
import Developments from "@/pages/Developments";
import LandJV from "@/pages/LandJV";
import Advisory from "@/pages/Advisory";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import ArticleDetail from "@/pages/ArticleDetail";
import ClientStories from "@/pages/ClientStories";
import Consultation from "@/pages/Consultation";
import Legal from "@/pages/Legal";
import Sitemap from "@/pages/Sitemap";
import NotFound from "@/pages/NotFound";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollManager />
        <div className="min-h-screen flex flex-col bg-[#0B0C10]">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/destinations" element={<Destinations />} />
              <Route path="/destinations/:slug" element={<DestinationDetail />} />
              <Route path="/opportunities" element={<Opportunities />} />
              <Route path="/opportunities/:slug" element={<ProjectDetail />} />
              <Route path="/developments" element={<Developments />} />
              <Route path="/developments/:slug" element={<ProjectDetail />} />
              <Route path="/land-development-jv" element={<LandJV />} />
              <Route path="/advisory" element={<Advisory />} />
              <Route path="/about" element={<About />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<ArticleDetail />} />
              <Route path="/client-stories" element={<ClientStories />} />
              <Route path="/private-consultation" element={<Consultation />} />
              <Route path="/privacy-policy" element={<Legal page="privacy" />} />
              <Route path="/terms-of-use" element={<Legal page="terms" />} />
              <Route path="/disclaimer" element={<Legal page="disclaimer" />} />
              <Route path="/cookie-policy" element={<Legal page="cookies" />} />
              <Route path="/sitemap" element={<Sitemap />} />
              <Route path="/insights/branded-residences-dubai-uae" element={<Navigate to="/insights/branded-residences-uae-guide" replace />} />
              <Route path="/insights/uae-golden-visa-property" element={<Navigate to="/insights/uae-golden-visa-through-property" replace />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
          <MobileActionBar />
          <Toaster theme="dark" position="bottom-center" />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
